export default __webpack_public_path__ + "static/media/E-commerceRealCase2.8678c955.jpg";